<template>
  <div>
    <v-dialog v-model="loginDialog" width="500">
      <v-card>
        <v-container>
          <LoginDialog />
        </v-container>
      </v-card>
    </v-dialog>

    <div v-if="!globalStatus">
      <toolbar />
      <navbar />
      <v-content>
        <keep-alive max="5" :include="include">
          <router-view></router-view>
        </keep-alive>
      </v-content>
    </div>
    <div v-else>
      <v-dialog v-model="globalStatus" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            {{ $t("labels.pleaseStandBy") }}
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="loadingStatus.status" persistent width="300">
      <v-card color="purple darken-3" dark>
        <v-card-text>
          {{ loadingStatus.title }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import layoutStore from "./store";
import integrationStore from "../Integration/store.js";
import Navbar from "@/modules/Layout/components/NavigationPanel.vue";
import Toolbar from "@/modules/Layout/components/Toolbar.vue";
import backofficeService from "../../api/backoffice.js";
import LoginDialog from "../Authentication/components/LoginDialog";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "layout",
  mixins: [RegisterStoreModule],
  async created() {
    try {
      this.registerStoreModule("layout", layoutStore);
      // await this.registerStoreModule('integration', integrationStore)
      // await this.registerStoreModule('settings', settingStore)
      // await this.registerStoreModule('tasks', tasksStore)
      // await this.checkToken()
      await this.$store.dispatch("global/initComboBox");
      await this.$store.dispatch("global/initUser");
      // await this.$store.dispatch('global/initOrganization')
      await this.$store.dispatch("global/initState");
      this.setGlobalStatus(false);
      // await this.$store.dispatch('tasks/initTasks')
      this.pollData();
      this.joinSocket();
    } catch (error) {
      this.$router.push("/logout");
    }
  },
  components: {
    Navbar,
    Toolbar,
    LoginDialog,
  },
  sockets: {
    connect: function() {
      // console.log('socket connected')
      this.joinSocket();
    },
    message: function(data) {
      // console.log('message', data)
    }
  },
  computed: {
    ...mapGetters("global", ["currentUser", "globalStatus", "loadingStatus", "loginDialog"])
  },
  props: {
    source: String
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  data() {
    return {
      include: ["home", "open-invoice"],
      authenticated: true,
      polling: null
    };
  },
  watch: {
    $route(to, from) {
      if (to && from && to.name !== from.name) {
        let status = {
          to: to.fullPath,
          from: from.fullPath,
          userID: this.currentUser.userID,
          userName: this.currentUser.fullName,
          date: new Date()
        };
        this.sendSocket(status);
      }
    },
    authenticated(val) {
      console.log("watch vale", val);
      if (!val) {
        this.$swal("Session Expired", "Your token was expaired please login again.", "warning").then(
          () => {
            // this.$router.push("/login");
            this.setLoginDialog(true)
          }
        );
      }
    }
  },
  methods: {
    ...mapActions("global", ["setGlobalStatus", "setLoginDialog"]),
    sendSocket(data) {
      // console.log('sendSocket', data)
      this.$socket.emit("userStatus", data);
    },
    joinSocket() {
      if (this.currentUser) {
        this.$socket.emit("join", this.currentUser);
      }
    },
    async checkToken() {
      this.authenticated = await backofficeService.valid();
    },
    pollData() {
      this.polling = setInterval(() => {
        if (!localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`)) {
          this.authenticated = false;
        }
      }, 1000);
    }
  }
};
</script>
